/* eslint-disable import/no-named-as-default-member, import/no-named-as-default, no-console */
import { getProductByHandle } from '../utils/storefront/get-products';
import getLineItemAttributes from '../utils/storefront/get-attributes';

/**
 * Global ATC functionality to expose ATC to third parties
 * @param {Object} params
 * @param {string} params.handle Product handle
 * @param {Integer|string} [params.variantId] variant ID.
 *   must be a variant ID within the product matching the handle provided
 * @param {Integer|string} [params.quantity=1] quantity to add to cart.
 * @returns null
 */
async function globalAddToCart({ handle, variantId, quantity = 1 }) {
  if (!handle) {
    console.warn('product handle required to add to cart');
    return null;
  }
  const productData = await getProductByHandle(handle);
  const product = productData?.data?.productByHandle;

  if (!product) {
    console.warn(`Product with handle "${handle}" not found`);
    return null;
  }

  const defaultVariant = product.variants?.edges[0]?.node;
  let targetVariant = null;

  // if variantId is provided,
  // find the variant that matches the ID
  if (variantId) {
    targetVariant = product.variants?.edges?.find(
      (edge) =>
        parseInt(
          edge.node.id.replace('gid://shopify/ProductVariant/', ''),
          10,
        ) === parseInt(variantId, 10),
    )?.node;

    if (!targetVariant) {
      console.warn(`Variant ID ${variantId} not found in ${product.title}`);
      return null;
    }
  }

  const variant = targetVariant || defaultVariant;

  if (!variant) {
    console.warn(`Variant not found in ${product.title}`);
    return null;
  }

  const attributes = getLineItemAttributes({
    product,
    variant,
  });

  const cartAddPayload = {
    detail: {
      payload: {
        id: variant.id,
        quantity: parseInt(quantity, 10),
        attributes,
      },
    },
  };

  const addToCartEvent = new CustomEvent('cart:add', cartAddPayload);
  document.dispatchEvent(addToCartEvent);

  return null;
}

export default globalAddToCart;
